import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isIos } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.Simulator
const label = visitFilterLabelMap[key]

export const simulatorColumn = () =>
  columnHelper.display({
    id: 'simulator',
    header: 'iOS Simulator',
    cell: ({ row }) => {
      if (!isIos(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.simulator

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
